module.exports = __webpack_public_path__ + "static/media/fly0065.801b9892.webp";